import { useState, useMemo } from 'react';
import { GroupMember } from '../../../types/groupDetail';

export const useMemberSelection = (members: GroupMember[], searchQuery: string) => {
  const [selectedMembers, setSelectedMembers] = useState<GroupMember[]>([]);

  // Filter members by search query
  const filteredMembers = useMemo(() => 
    members.filter(member => 
      member.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      member.role.toLowerCase().includes(searchQuery.toLowerCase())
    ),
    [members, searchQuery]
  );

  const handleSelectAll = (checked: boolean) => {
    if (checked) {
      setSelectedMembers(filteredMembers);
    } else {
      setSelectedMembers([]);
    }
  };

  const handleSelectMember = (member: GroupMember, checked: boolean) => {
    if (checked) {
      setSelectedMembers([...selectedMembers, member]);
    } else {
      setSelectedMembers(selectedMembers.filter(m => m.id !== member.id));
    }
  };

  const clearSelection = () => {
    setSelectedMembers([]);
  };

  const handleBulkRoleChange = (newRole: 'Member' | 'Assistant Leader' | 'Group Leader') => {
    console.log(`Changing role of ${selectedMembers.length} members to: ${newRole}`);
    // In a real app, this would update the backend
    clearSelection();
  };

  const handleBulkRemove = () => {
    console.log(`Removing ${selectedMembers.length} members`);
    // In a real app, this would update the backend
    clearSelection();
  };

  const isAllSelected = filteredMembers.length > 0 && selectedMembers.length === filteredMembers.length;
  const isMemberSelected = (member: GroupMember) => selectedMembers.some(m => m.id === member.id);

  return {
    selectedMembers,
    filteredMembers,
    handleSelectAll,
    handleSelectMember,
    clearSelection,
    handleBulkRoleChange,
    handleBulkRemove,
    isAllSelected,
    isMemberSelected,
  };
};
